/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.programs.detail.controllers', [
  'acme.common.service.calendar'
])

.controller('ProgramsDetailController', ['$scope', '$sce', '$state', '$log', 'ResolveViewData', 'CalendarService', function($scope, $sce, $state, $log, ResolveViewData, CalendarService) {

    $scope.programsDetail = {

      safeDescription: '',

      model: {},
      primaryImage: {},

      links: [
        {
          name: 'Schedule',
          sref: 'application.programsDetail.chart'
        },
        {
          name: 'Dependents',
          sref: 'application.programsDetail.dependents'
        },
        {
          name: 'Upsells',
          sref: 'application.programsDetail.upsells'
        }
      ],

      init: function () {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Event Template',
          buttonRight: {
            label: 'Edit Template',
            permissions: 'EVENT_TEMPLATE_UPDATE',
            action: function() {
              $state.go('application.templates.edit.description', { id: $scope.programsDetail.model.id });
            }
          }
        });

        if (ResolveViewData.data.success) {
          this.success.init(ResolveViewData);
        }else{
          this.error.init(ResolveViewData);
        }
      },

      getPrimaryImage: function() {
        var i, ii;

        if (this.model.images instanceof Array) {
          for (i=0,ii=this.model.images.length;i<ii;i++) {
            if (this.model.images[i].primary === true) {
              this.primaryImage = this.model.images[i];
            }
          }
        }
      },

      success: {
        init: function(response) {
          if (!response.data.payload) { return; }
          $scope.programsDetail.model = response.data.payload;
          $scope.programsDetail.model.startTime = CalendarService.parseDate($scope.programsDetail.model.startTime);
          $scope.programsDetail.model.endTime = CalendarService.parseDate($scope.programsDetail.model.endTime);
          $scope.programsDetail.safeDescription = $sce.trustAsHtml($scope.programsDetail.model.description);
          $scope.programsDetail.getPrimaryImage();
        }
      },

      error: {
        init: function(response) {

        }
      }

    };

    $scope.programsDetail.init();

}]);